<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
// Same slot contract as BcSheet but no popup of its own: lets PagePickerSheet render inside a sheet
// that is already open (embedded mode), so only one BcSheet owns the browser-history entry.
export default {
  name: "BcFlat",
  inheritAttrs: false,
};
</script>

